import Icons from "../assets/icon/index";
const TalentFavouritesData = [
    {
        id: 1,
        title: "Events",
        bgColor: "#D2BFDB",
        icon: Icons.favEventIcon,
        to: "/favourites-events"
    },
    {
        id: 2,
        title: "News",
        bgColor: "#B2E6C7",
        icon: Icons.favNewsIcon,
        to: "/favourites-news"
    },
    {
        id: 3,
        title: "Jobs",
        bgColor: "#EBD7CF",
        icon: Icons.favJobsIcon,
        to: "/favourites-jobs"
    },
];
export default TalentFavouritesData;